import { render, staticRenderFns } from "./BudgetList.vue?vue&type=template&id=30bd4718&scoped=true&"
import script from "./BudgetList.vue?vue&type=script&lang=js&"
export * from "./BudgetList.vue?vue&type=script&lang=js&"
import style0 from "./BudgetList.vue?vue&type=style&index=0&id=30bd4718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd4718",
  null
  
)

export default component.exports